import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  stepNumber: {
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: 14,
    backgroundColor: COLOR_PURPLE,
    borderRadius: '50%',
    padding: '2px 7px 4px',
  },
  dividerPurple: {
    width: 136,
    height: 1,
    backgroundColor: COLOR_PURPLE,
  },
  stepNumberInactive: {
    fontWeight: 700,
    color: COLOR_PURPLE,
    fontSize: 14,
    backgroundColor: theme.palette.common.white,
    borderRadius: '50%',
    border: `1px solid ${COLOR_PURPLE}`,
    padding: '2px 7px 4px',
  },
}));
